import { useAtom } from "jotai";
import SvgComponent from "./SvgComponent";
import dashboardAtoms, {
  fetchActivitiesAtom,
  fetchBlocks,
  fetchMapRender,
  fetchOverallCpSVG,
  fetchPartsAtom,
  fetchTrackers,
  getActivity,
  getConstructionProgressList,
  getConstructionProgressListBlockWise
} from "../../atoms/Dashboard/DashboardAtom";
import { useEffect, useState, useCallback } from "react";
import ProgressComponent from "./ProgressComponent";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Box } from "@mui/material";
import settingsAtom from "../../atoms/settings/SettingsAtom";

const Dashboard = () => {
  const [data] = useAtom(dashboardAtoms);
  const [, setActivity] = useAtom(getActivity);
  const [, setProgress] = useAtom(getConstructionProgressList)
  const [, setSVGProgressBlockWise] = useAtom(getConstructionProgressListBlockWise)
  const [, setPart] = useAtom(fetchPartsAtom);
  const [, setTrackers] = useAtom(fetchTrackers);
  const [, setMap] = useAtom(fetchMapRender)
  const [loader, setLoader] = useState(false)
  const [visible, setVisible] = useState(true);
  const [currentSelection, setCurrentSelection] = useState("");
  const [, setBlocks] = useAtom(fetchBlocks);
  const [, setSvg] = useAtom(fetchOverallCpSVG);
  const [, setActivityList] = useAtom(fetchActivitiesAtom);
  const projectId = localStorage.getItem('project_id');
  const [selectBlock, setSelectBlock] = useState(false);
  const [selectPart, setSelectPart] = useState([]);
  const [isSelect, setIsSelect] = useState(false);
  const [activity, setActivities] = useState("All");
  const [partId, setPartId] = useState("All")
  const [trackers] = useState([]);
  const [selectedRow] = useState({})
  const [settingsData] = useAtom(settingsAtom);
  const { projectList } = settingsData;
  const currentProject = projectList.find(o => o.id === parseInt(localStorage.getItem("project_id")))


  const fetchAllData = useCallback(async () => {
    setLoader(true);
    try {
      await Promise.allSettled([
        setActivity(''),
        setTrackers(''),
        setBlocks(''),
        setMap(''),
        setProgress(''),
        setPart(''),
        setActivityList(''),
        setSvg('')
      ]);
    } catch (error) {
      console.error("Error in fetchAllData:", error);
    } finally {
      setLoader(false);
    }
  }, [setActivity, setTrackers, setBlocks, setMap, setProgress, setPart, setActivityList, setSvg]);

  useEffect(() => {
    if (projectId) {
      fetchAllData();
    }
  }, [projectId, fetchAllData]);

  const handleClickTracker = () => { return null };

  useEffect(() => {
    const fetchConstructionProgressBlockWise = async () => {
      try {
        if (activity !== "All" && partId !== "All")
          await setSVGProgressBlockWise({ activity_id: activity, part_id: partId })
      } catch (err) {
        console.error(err)
      }
    }
    fetchConstructionProgressBlockWise()
    // eslint-disable-next-line
  }, [activity])

  return (
    <Box sx={{ display: 'flex', width: '100%', position: "relative" }}>
      <Box sx={{ height: 'calc(100vh - 116px)', width: visible ? "65%" : "100%", borderRight: '1px solid #e0e0e0' }}>
        <SvgComponent
          active={currentSelection}
          data={data}
          loader={loader}
          setSelectBlock={setSelectBlock}
          setSelectPart={setSelectPart}
          selectBlock={selectBlock}
          selectPart={selectPart}
          isSelect={isSelect}
          setIsSelect={setIsSelect}
          activityId={activity}
        />
      </Box>
      {visible ?
        <Box sx={{ height: 'calc(100vh - 116px)', width: '35%' }}>
          <ProgressComponent
            loader={loader}
            data={data}
            currentSelection={currentSelection}
            setCurrentSelection={setCurrentSelection}
            setActivities={setActivities}
            handleClickTracker={handleClickTracker}
            trackers={trackers}
            selectedRow={selectedRow}
            setPartId={setPartId}
            selectPart={selectPart}
            activity={activity}
            setSelectPart={setSelectPart}
            selectBlock={selectBlock}
            setSelectBlock={setSelectBlock}
            currentProject={currentProject}

          />
        </Box> : ''}
      <Box
        onClick={() => setVisible(!visible)}
        style={{ right: visible ? '33%' : 0 }}
        sx={{
          height: "24px",
          border: "1px solid #e0e0e0",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "white",
          zIndex: 10,
          position: "absolute",
          top: 18,
          width: "24px",
          cursor: "pointer"
        }}
      >
        {visible ? <ChevronRight size={18} /> : <ChevronLeft size={18} />}
      </Box>
    </Box>
  );
};

export default Dashboard;